import {CONSONANT_VOWEL_PAIRS_PP} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_pp";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_PP_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_PP} title="Consonant-Vowel Pairs: ㅃ (pp)" />
     </>
);}